import React, { createContext, useContext, useState, useEffect } from "react";
import Cookies from "js-cookie";
import { toast } from "react-toastify";
import { handleErrors } from "../../utils/errorHandler";
import customerInfoServices from "../../services/customer-profile-services";
const UserContext = createContext();

export const UserProvider = ({ children }) => {
  const [user, setUser] = useState({
    isAuthenticated: false,
    userInfo: null,
  });

  const setAuthentication = (isAuthenticated) => {
    setUser((prevUser) => ({
      ...prevUser,
      isAuthenticated,
    }));
  };

  const fetchCustomerProfile = async () => {
    try {
      const response = await customerInfoServices.getProfileInfo();
      setUser((prevUser) => ({
        ...prevUser,
        userInfo: response.data.result,
        userRole: "Owner",
      }));
    } catch (error) {
      const errorMessage = handleErrors(error);
      toast.error(errorMessage);
    }
  };
  const fetchVendorProfile = async () => {
    try {
      const response = await customerInfoServices.getVendorProfileInfo();
      setUser((prevUser) => ({
        ...prevUser,
        userInfo: response.data.result,
        userRole: "Vendor",
      }));
    } catch (error) {
      const errorMessage = handleErrors(error);
      toast.error(errorMessage);
    }
  };

  const checkAuthentication = () => {
    const accessToken = Cookies.get("accessToken");
    setUser((prevUser) => ({
      ...prevUser,
      isAuthenticated: !!accessToken,
    }));
  };

  useEffect(() => {
    checkAuthentication();
    if (user.isAuthenticated) {
    }
  }, [user.isAuthenticated]);

  useEffect(() => {
    const userRole = Cookies.get("userRole");
    checkAuthentication();
    if (user.isAuthenticated && userRole === "U") {
      fetchCustomerProfile();
    }
    if (user.isAuthenticated && userRole === "V") {
      fetchVendorProfile();
    }
  }, [user.isAuthenticated]);

  return (
    <UserContext.Provider
      value={{
        user,
        setUser,
        setAuthentication,
      }}
    >
      {children}
    </UserContext.Provider>
  );
};

export const useUser = () => {
  return useContext(UserContext);
};
